import type { ParsedFmbDishRow } from "./parse-fmb-dish-csv";

/** Maps parsed dish rows to the POST /fmbDish/bulk-import body shape. */
export function fmbDishRowsToImportPayload(rows: ParsedFmbDishRow[]) {
  return rows.map((r) => ({
    name: r.name,
    dietaryType: r.dietaryType,
    description: r.description,
    imageUrl: r.imageUrl,
    sourceRowNumber: r.sourceRowNumber,
  }));
}
